<template>
  <div>
    <vue-headful title="Notificaties" />
    <Header page_title="Notificaties" />
    <div class="">
      <div class="container-fluid px-4 mx-2">
        <form @submit.prevent="onSubmit" class="mb-5 mt-5 ">
          <NotificationContainer />
          <div v-if="user.type == 1" class="clearfix">
            <div class="float-left">
              <div class="custom-control custom-switch">
                <input
                  id="notification_matched"
                  type="checkbox"
                  class="custom-control-input"
                  v-model="form.notification_matched"
                />
                <label
                  class="custom-control-label"
                  for="notification_matched"
                ></label>
              </div>
            </div>
            <div class="float-left">
              <label class="toggle-label" for="notification_matched">Stuur e-mail</label>
            </div>
          </div>
          <div v-if="user.type == 1" class="clearfix">
            <div class="float-left">
              <div class="custom-control custom-switch">
                <input
                  id="notification_matched_sms"
                  type="checkbox"
                  class="custom-control-input"
                  v-model="form.notification_matched_sms"
                />
                <label
                  class="custom-control-label"
                  for="notification_matched_sms"
                ></label>
              </div>
            </div>
            <div class="float-left">
              <label class="toggle-label" for="notification_matched_sms">Stuur sms bij een nieuwe match</label>
            </div>
          </div>
          <div v-if="user.type == 2" class="clearfix">
            <div class="float-left">
              <div class="custom-control custom-switch">
                <input
                  id="notification_applicant"
                  type="checkbox"
                  class="custom-control-input"
                  v-model="form.notification_applicant"
                />
                <label
                  class="custom-control-label"
                  for="notification_applicant"
                ></label>
              </div>
            </div>
            <div class="float-left">
              <label class="toggle-label" for="notification_applicant">Stuur e-mail</label>
            </div>
          </div>
          <div class="clearfix">
            <div class="float-left">
                <div class="custom-control custom-switch">
                    <input
                      id="notification_newsletter"
                      type="checkbox"
                      class="custom-control-input"
                      v-model="form.notification_newsletter"
                    />
                    <label
                      class="custom-control-label"
                      for="notification_newsletter"
                    ></label>
                </div>
            </div>
            <div class="float-left">
              <label class="toggle-label" for="notification_newsletter">Inschrijven op nieuwsbrief</label>
            </div>
          </div>
          <button type="submit" class="btn btn-warning btn-block">Opslaan</button>
        </form>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      user: "",
      form: {
        notification_matched: "",
        notification_matched_sms: "",
        notification_applicant: "",
        notification_newsletter: ""
      }
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      if (this.user.type == 1) {
        delete this.form["notification_applicant"]; // remove
        this.form.notification_matched = this.user.notification_matched;
        this.form.notification_matched_sms = this.user.notification_matched_sms;
      }
      if (this.user.type == 2) {
        delete this.form["notification_matched"]; // remove
        delete this.form["notification_matched_sms"]; // remove
        this.form.notification_applicant = this.user.notification_applicant;
      }
      this.form.notification_newsletter = this.user.notification_newsletter;
      this.$store.state.loading = false;
    },
    onSubmit() {
      //   save changes
      let formData = new FormData();
      for (var obj in this.form) {
        formData.append(obj, this.form[obj] ? 1 : 0);
      }
      var user_token = JSON.parse(localStorage.getItem("user-token"));
      var url =
        this.$apiURI + (this.user.type == 2 ? "/company" : "/applicant");
      this.$http
        .post(url, formData, {
          headers: {
            Authorization: "Bearer " + user_token,
            Accept: "application/json"
          }
        })
        .then(() => {
          // console.log(success);
          const notification = {
            type: "success",
            message: "Je hebt je gegevens succesvol aangepast. "
          };
          this.$store.dispatch("notification/replace", notification, {
            root: true
          });
          this.$store.state.loading = false;
          this.updateLocalUser();
        })
        .catch(() => {
          // console.log(error);
          const notification = {
            type: "danger",
            message: "Er is een fout opgetreden."
          };
          this.$store.dispatch("notification/replace", notification, {
            root: true
          });
          this.$store.state.loading = false;
        });
    }
  }
};
</script>

<style scoped>
  .toggle-label {
      font-size: 14px;
  }
</style>
